import { $Qll, $Q } from "graditify-utils";

/**
 * Listen event change radio inputs to check and update label
 * @param {node} selector component parent
 * @param {node} dropdown list elements wrapper
 * @returns null - stop called
 */
function checkEvent(selector, dropdown) {
  const radioEl = $Qll('input[type="radio"]', selector)
  const label = $Q('.custom-select__selector__label', selector)

  if (!radioEl.length) return

  radioEl.forEach((radio) => {
    radio.addEventListener('change', (e) => {

      if (!label) return
      label.textContent = e.target.value
      dropdown.setAttribute("data-active", "false");
    })
  })
}

/**
 * The function `executeCustomSelects` adds event listeners
 * to custom select dropdowns to toggle their
 * visibility and change the label when an option is selected.
 */
export default function executeCustomSelects() {
  const selectors = $Qll(".custom-select");
  selectors.forEach((selector) => {
    const toggleBtn = $Q(".custom-select__selector", selector);
    const dropdown = $Q(".custom-select__dropdown", selector);
    const label = $Q(".js-label-custom-select", selector);

    checkEvent(selector, dropdown)

    toggleBtn.addEventListener("click", () => {
      if (dropdown.dataset.active === "false") {
        dropdown.setAttribute("data-active", "true");
        label.setAttribute("data-active-dropdown", "true");
      } else {
        dropdown.setAttribute("data-active", "false");
        label.setAttribute("data-active-dropdown", "false");
      }
    }, {passive: false})
  })

  document.addEventListener("click", (e) => {
    if (!e.target.closest(".custom-select")) {
      const dropdowns = $Qll(".custom-select__dropdown")
      dropdowns.forEach((drop) => {
        drop.setAttribute("data-active", "false")
      })
    }
  }, {passive: false})
}
